<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Add Delivery Staff",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Add Delivery Staff",
            items: [
               {
                  text: "Delivery Staffs",
                  href: "/delivery-staffs",
               },
               {
                  text: "Add Delivery Staff",
                  active: true,
               },        
            ],

            staff: {
               name: '',
               mobile: '',
               whatsapp: '',
               email: '',
               address: '',
               id_proof: '',
            },

            image: "",
            preview_image: "",

            errors: {},
            
            loading: false,

         };
      },
      mounted() {
    
      },

      methods: {

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         alphaSpacesOnly(event) {
            let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32)) {
                 return;
            } else {
               event.preventDefault();
            }
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         addStaff() {
            this.getToken();
            this.loading = true;
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/delivery-staffs/add";

            let formData = new FormData();
            formData.append("name", this.staff.name); 
            formData.append("email", this.staff.email); 
            formData.append("mobile", this.staff.mobile); 
            
            formData.append("whatsapp", this.staff.whatsapp); 
            formData.append("address", this.staff.address); 

            formData.append("id_proof", this.image); 
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: 'deliverystaffs'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         clearForm() {        
            this.staff.name = "";
            this.staff.email = "";
            this.staff.mobile = "";
            this.staff.whatsapp = "";
            this.staff.address = "";
            this.staff.id_proof = "";
            this.image = "";
            this.preview_image = "";
            
            this.errors = {};
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'deliverystaffs' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="addStaff()">
                        <div class="row">
                           <div class="form-group col-md-6">
                              <label>Name <span class="text-danger">*</span></label>
                              <input type="text" v-model="staff.name" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.name) }" @keypress="alphaSpacesOnly"/>

                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>                     
                                 
                           <div class="form-group col-md-6">
                              <label>Mobile No. <span class="text-danger">*</span></label>
                              <b-input-group size="md" prepend="+91">
                                 <b-form-input v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }" v-model="staff.mobile" @keypress="numbersOnly" maxlength="10"></b-form-input>                            
                                 <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>
                           </div>

                           <div class="form-group col-md-6">
                              <label>Email <span class="text-danger">*</span></label>
                              <input type="email" v-model="staff.email" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.email) }" />

                              <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>

                           <div class="form-group col-md-6">
                              <label>Whatsapp No. <span class="text-danger">*</span></label>

                              <b-input-group size="md" prepend="+91">
                                 <b-form-input v-bind:class="{ 'is-invalid': Boolean(errors.whatsapp) }" v-model="staff.whatsapp"></b-form-input>                            
                              
                                 <div v-for="(val, index) in errors.whatsapp" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>
                           </div>

                           <div class="form-group col-md-12">
                              <label>Address</label>
                              <textarea rows="2" v-model="staff.address" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.address) }"></textarea>

                              <div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>   

                           <div class="form-group col-md-6">
                              <label>ID Proof  <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>

                            
                              <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.id_proof) }" />
                              <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                              <div v-for="(val, index) in errors.id_proof" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>                        
                           
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <div v-if="loading" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" type="submit">Save</button>
                                 <router-link :to="{ name: 'deliverystaffs' }" class="btn btn-light">Cancel</router-link>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>

   <style scoped>
      .page-loader {
         display: flex;
         align-items: center;
         padding: 10px 0;
      }

      .page-loader img {
         width: 50px;
         height: 50px;
      }
   </style>
